import React from "react";
import ZoomPan from "@/components/ZoomPan";

/**
 * SvgViewer - renders a raw SVG string returned by the backend (sections,
 * elevations, slab plans …) inside a wheel-zoom / drag-pan viewport.
 */
export default function SvgViewer({ svg, className = "h-[560px]" }) {
  if (!svg) return null;
  return (
    <ZoomPan className={className}>
      <div className="abl-svg-host min-w-[600px] p-4" dangerouslySetInnerHTML={{ __html: svg }} />
    </ZoomPan>
  );
}
